import { BaseDetail } from 'App/Component/Bases'
import fields from './fields'

class PageAdd extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = 'Tag'
    this.urlData = 'module-merchant-tag'
    this.fields = fields
    this.state = {
      isCheckingPermission: false,
      isAccessAllowed: true,
    }
  }
}

export default PageAdd